
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/expensetracker/version/latest/download",
      function () {
        return require("private-next-pages/apps/expensetracker/version/latest/download.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/expensetracker/version/latest/download"])
      });
    }
  